import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Box, Flex, Text, SvgIcon, ButtonOutlined } from 'Components/Base';
import ArticleBox from 'Components/Classroom/Content/ArticleBox';

const ArticleFragment = ({ title, content, ...articleBoxProps }) => {
  const [height, setHeight] = useState('auto');
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current.clientHeight > 280) {
      setHeight('280px');
    }
  }, []);

  return (
    <Flex alignItems={'center'} flexDirection={'column'}>
      <Box>
        <Text fontSize={5}>{title}</Text>
        <Flex ref={ref} height={height} overflow={'hidden'}>
          <ArticleBox rawContent={content} {...articleBoxProps} />
        </Flex>
      </Box>
      {height === '280px' && (
        <ButtonOutlined
          color={'primary'}
          mt={2}
          variant={'small'}
          onClick={() => {
            setHeight('auto');
          }}
        >
          <Flex alignItems={'center'} width={'100%'} justifyContent={'space-around'}>
            ดูเพิ่มเติม
            <SvgIcon icon={SvgIcon.ICON_LIST.ARROW_DOWN} size={20} />
          </Flex>
        </ButtonOutlined>
      )}
    </Flex>
  );
};

ArticleFragment.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
};

export default ArticleFragment;
